import {Dispatch, UnknownAction} from '@reduxjs/toolkit';

import {useDispatch} from 'react-redux';

import {mergeTelephonyCallState, telephonyApi, TelephonyCall} from '@dms/api/settings';

/**
 * The app store declares its state without the RTK Query reducer paths, so the default dispatch
 * rejects a cache-patching thunk the store accepts at runtime. Narrowed to this one thunk.
 */
type TelephonyCallCacheDispatch = Dispatch<UnknownAction> & {
  (thunk: ReturnType<typeof telephonyApi.util.updateQueryData>): unknown;
};

/**
 * Writes a call state into the shared current-call cache entry. Every writer (pushes, resync, the
 * optimistic `ringing_user` seed after `POST /calls`) goes through `mergeTelephonyCallState`, so no
 * source can move the state backwards or hide a call that started meanwhile.
 */
export function useApplyTelephonyCallState() {
  const dispatch = useDispatch<TelephonyCallCacheDispatch>();

  return (incoming: TelephonyCall) =>
    dispatch(
      telephonyApi.util.updateQueryData('getTelephonyCurrentCall', undefined, (draft) =>
        mergeTelephonyCallState(draft, incoming)
      )
    );
}
